import { createContext, useCallback, useContext, useRef, useState, type ReactNode } from "react";

type Tipo = "ok" | "erro" | "info";
type Aviso = { mensagem: string; tipo: Tipo; id: number };

const ContextoToast = createContext<(mensagem: string, tipo?: Tipo) => void>(() => {});

export function ProvedorToast({ children }: { children: ReactNode }) {
  const [aviso, setAviso] = useState<Aviso | null>(null);
  const temporizador = useRef<ReturnType<typeof setTimeout>>(undefined);

  const mostrar = useCallback((mensagem: string, tipo: Tipo = "ok") => {
    clearTimeout(temporizador.current);
    setAviso({ mensagem, tipo, id: Date.now() });
    temporizador.current = setTimeout(() => setAviso(null), tipo === "erro" ? 4200 : 2600);
  }, []);

  return (
    <ContextoToast.Provider value={mostrar}>
      {children}
      {/* Região fixa para leitores de tela; o aviso visual é decorativo para não ser lido duas vezes. */}
      <div aria-live="polite" role="status" className="sr-only">
        {aviso?.mensagem}
      </div>
      {aviso && (
        <div key={aviso.id} className={`toast ${aviso.tipo === "ok" ? "" : aviso.tipo}`} aria-hidden="true">
          {aviso.mensagem}
        </div>
      )}
    </ContextoToast.Provider>
  );
}

export const useToast = () => useContext(ContextoToast);
